var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#efefef",
    width: "800px",
    height: "800px",
    viewBox: "-7.5 0 32 28",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#efefef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "eight"), /*#__PURE__*/React.createElement("path", {
    d: "M12.313 12.906c2.094 1.25 3.5 3.531 3.5 6.125 0 3.938-3.188 7.094-7.094 7.094-3.938 0-7.125-3.156-7.125-7.094 0-2.594 1.375-4.875 3.469-6.125-1.469-1.094-2.438-2.844-2.438-4.813 0-3.375 2.719-6.094 6.094-6.094s6.031 2.719 6.031 6.094c0 1.969-0.938 3.719-2.438 4.813zM4.875 8.094c0 2.125 1.719 3.844 3.844 3.844s3.813-1.719 3.813-3.844-1.688-3.844-3.813-3.844-3.844 1.719-3.844 3.844zM8.719 23.938c2.688 0 4.844-2.219 4.844-4.906s-2.156-4.875-4.844-4.875-4.906 2.188-4.906 4.875 2.219 4.906 4.906 4.906z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEight);
export default __webpack_public_path__ + "static/media/eight.1a72c63a2ed6a16bb5d5dbca05e35c6a.svg";
export { ForwardRef as ReactComponent };